import {Typography} from "@mui/material";
import styles from '../../styles/PageHeader.module.css'

export default function PageHeader({text}) {
    return (
        <Typography variant="h1"
                    component="h1"
                    color="primary"
                    gutterBottom
                    className={styles.pageHeader}
        >
            {text}
        </Typography>
    )
}
